import { render, staticRenderFns } from "./ProductHistoricalModal.vue?vue&type=template&id=d03013ac&"
import script from "./ProductHistoricalModal.vue?vue&type=script&lang=ts&"
export * from "./ProductHistoricalModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports